/**
 * n-cart-collection.js
 * ────────────────────
 * Suggerimenti "completa-carrello":
 *  - visibilità della sezione legata ai traguardi degli sconti progressivi
 *    (fallback: soglie min/max della sezione)
 *  - esclusione dei prodotti già in carrello:
 *      · slider attivo  → re-render server-side della sezione
 *        (Section Rendering API): il liquid rifà i filtri e lo
 *        slider viene ricostruito integro, nessun artefatto layout
 *      · griglia semplice → nasconde le card client-side e ordina
 *        per "fit" con l'importo mancante al prossimo traguardo
 *  - refresh automatico della pagina carrello se il DOM è indietro
 *    rispetto allo stato reale (es. add da griglia con carrello vuoto)
 */

(function () {
  /* Subtotale dopo gli sconti prodotto e prima degli sconti ordine. */
  function promotionSubtotal(cart) {
    if (window.NProgressiveDiscounts && typeof window.NProgressiveDiscounts.subtotal === "function") {
      return window.NProgressiveDiscounts.subtotal(cart);
    }
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    return subtotal > 0 ? subtotal : 0;
  }

  /* Traguardi dal DOM della barra sconti (spedizione + fasce). */
  function promotionTargets() {
    var c = document.querySelector(".npd-container");
    if (!c) return null;
    var targets = [];
    var st = parseInt(c.dataset.shippingThreshold, 10) || 0;
    if (st > 0) {
      targets.push({ threshold: st, label: c.dataset.shippingLabel || "la spedizione gratuita" });
    }
    c.querySelectorAll("[data-tier-threshold]").forEach(function (el) {
      targets.push({
        threshold: parseInt(el.dataset.tierThreshold, 10) || 0,
        label: el.dataset.tierLabel || ("il " + (el.dataset.tierDiscount || "") + "% di sconto"),
      });
    });
    targets.sort(function (a, b) { return a.threshold - b.threshold; });
    return targets.length ? targets : null;
  }

  function nextTarget(targets, total) {
    if (!targets) return null;
    for (var i = 0; i < targets.length; i++) {
      if (total < targets[i].threshold) return targets[i];
    }
    return null;
  }

  /* ── Re-render server-side della sezione (per la modalità slider) ── */
  function rerenderSection(section) {
    var sid = section.dataset.sectionId;
    var wrapper = section.closest(".shopify-section");
    if (!sid || !wrapper || section.dataset.rerendering === "1") return;
    section.dataset.rerendering = "1";

    fetch("/cart?sections=" + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sid];
        if (html == null) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.firstElementChild;
        if (fresh) {
          var freshInner = fresh.querySelector(".cart-collection-section");
          if (freshInner) freshInner.setAttribute("data-hidden", "false");
          wrapper.replaceWith(fresh);
        }
      })
      .catch(function (err) {
        console.error("[cart-collection] Errore re-render sezione:", err);
        section.dataset.rerendering = "";
      });
  }

  /* ── Modalità griglia: nascondi esclusi e ordina per gap ── */
  function updateCardsGrid(section, cart, next, total, excludedHandles) {
    var lis = Array.prototype.slice.call(section.querySelectorAll("[data-suggest-price]"));
    if (!lis.length) return 1;

    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = true; });

    var visible = [];
    lis.forEach(function (li) {
      var h = li.dataset.suggestHandle;
      if (inCart[h] || excludedHandles[h]) {
        li.style.display = "none";
      } else {
        li.style.display = "";
        visible.push(li);
      }
    });

    var gap = next ? next.threshold - total : 0;

    if (next && gap > 0) {
      visible.sort(function (a, b) {
        var pa = parseInt(a.dataset.suggestPrice, 10) || 0;
        var pb = parseInt(b.dataset.suggestPrice, 10) || 0;
        var sa = pa >= gap ? pa - gap : gap - pa + 1000000;
        var sb = pb >= gap ? pb - gap : gap - pb + 1000000;
        return sa - sb;
      });
      var ul = section.querySelector(".product-grid");
      if (ul) {
        visible.forEach(function (li) { ul.appendChild(li); });
      }
    }

    return visible.length;
  }

  /* ── Visibilità e gestione card ── */
  function checkVisibility(cart, targets, next, total) {
    document.querySelectorAll(".cart-collection-section").forEach(function (section) {
      var minThreshold = parseInt(section.dataset.minThreshold, 10) || 0;
      var maxThreshold = parseInt(section.dataset.threshold, 10);
      var hidden;

      if (cart.item_count === 0 || total < minThreshold) {
        hidden = true;
      } else if (targets) {
        /* Barra progressiva presente: visibile finché c'è una fascia da sbloccare. */
        hidden = !next;
      } else {
        /* Fallback: logica a soglia massima della sezione */
        hidden = !isNaN(maxThreshold) && total >= maxThreshold;
      }

      if (!hidden) {
        var ul = section.querySelector(".product-grid");
        var sliderActive = !!(ul && ul.classList.contains("slider"));

        if (sliderActive) {
          /* Slider: niente display:none/riordino (rompono il layout).
             Se una card corrisponde a un prodotto ora in carrello,
             la sezione viene ri-renderizzata dal server. */
          var inCart = {};
          cart.items.forEach(function (i) { inCart[i.handle] = true; });
          var lis = section.querySelectorAll("[data-suggest-handle]");
          var stale = false;
          for (var i = 0; i < lis.length; i++) {
            if (inCart[lis[i].dataset.suggestHandle]) { stale = true; break; }
          }
          if (stale) rerenderSection(section);
        } else {
          var visibleCount = updateCardsGrid(section, cart, next, total, {});
          var hasCards = section.querySelectorAll("[data-suggest-price]").length > 0;
          if (hasCards && visibleCount === 0) hidden = true;
        }
      }

      section.setAttribute("data-hidden", hidden ? "true" : "false");
    });
  }

  /* ── Refresh pagina carrello se il DOM è indietro ── */
  var _refreshing = false;

  function refreshCartSections() {
    if (_refreshing) return;
    var main = document.getElementById("main-cart-items");
    if (!main || !main.dataset.id) return;
    _refreshing = true;

    var ids = [main.dataset.id];
    var footer = document.getElementById("main-cart-footer");
    if (footer && footer.dataset.id && ids.indexOf(footer.dataset.id) === -1) {
      ids.push(footer.dataset.id);
    }
    ids.push("cart-icon-bubble");

    fetch("/cart?sections=" + ids.join(","))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        var mainHtml = sections[main.dataset.id];
        if (mainHtml) {
          var doc = parser.parseFromString(mainHtml, "text/html");
          var freshCartItems = doc.querySelector("cart-items");
          var currentCartItems = main.closest("cart-items");
          if (freshCartItems && currentCartItems) {
            currentCartItems.replaceWith(freshCartItems);
          }
        }

        if (footer && footer.dataset.id && sections[footer.dataset.id]) {
          var fdoc = parser.parseFromString(sections[footer.dataset.id], "text/html");
          var freshFooter = fdoc.getElementById("main-cart-footer");
          if (freshFooter) footer.replaceWith(freshFooter);
        }

        var bubble = document.getElementById("cart-icon-bubble");
        if (bubble && sections["cart-icon-bubble"]) {
          var bdoc = parser.parseFromString(sections["cart-icon-bubble"], "text/html");
          var freshBubble = bdoc.querySelector(".shopify-section");
          if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }
      })
      .catch(function (err) {
        console.error("[cart-collection] Errore refresh sezioni:", err);
      })
      .finally(function () {
        _refreshing = false;
      });
  }

  /* ── Update principale ── */
  function update() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = promotionSubtotal(cart);
        var targets = promotionTargets();
        var next = nextTarget(targets, total);

        checkVisibility(cart, targets, next, total);

        var main = document.getElementById("main-cart-items");
        if (main) {
          var domRows = main.querySelectorAll(".cart-item").length;
          if (domRows !== cart.items.length) {
            refreshCartSections();
          }
        }
      })
      .catch(function (err) {
        console.error("[cart-collection] Errore fetch carrello:", err);
      });
  }

  document.querySelectorAll(".cart-collection-section").forEach(function (section) {
    section.setAttribute("data-hidden", "true");
  });

  if (!window.__nCartCollectionReloadBound) {
    window.__nCartCollectionReloadBound = true;
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-cart-collection-reload]");
      if (!button) return;
      button.disabled = true;
      button.classList.add("is-loading");
      button.setAttribute("aria-busy", "true");
      var label = button.querySelector("[data-reload-label]");
      if (label && button.dataset.loadingLabel) label.textContent = button.dataset.loadingLabel;
      window.location.reload();
    });
  }

  update();

  document.addEventListener("cart:updated", update);
  document.addEventListener("cart:refresh", function () { setTimeout(update, 300); });
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(update, 100); });
  }
})();
